import type { CanvasClass, CreativeRole, TemplateZone } from './creative-template.types';

export type LayerContentKind = 'fill' | 'image' | 'text' | 'shape';

export type BindableField =
  | 'fill_color'
  | 'color'
  | 'background_color'
  | 'text_color'
  | 'font_family'
  | 'content'
  | 'label'
  | 'media_url';

export interface FillLayerContent {
  kind: 'fill';
  fill_color: string;
}

export interface ImageLayerContent {
  kind: 'image';
  media_url: string | null;
  label: string;
}

export interface TextLayerContent {
  kind: 'text';
  content: string;
  font_family: string;
  text_color: string;
  font_size: number | null;
}

export interface ShapeLayerContent {
  kind: 'shape';
  fill_color: string;
}

export type LayerContent =
  | FillLayerContent
  | ImageLayerContent
  | TextLayerContent
  | ShapeLayerContent;

export interface SceneLayer {
  role: CreativeRole;
  zone: TemplateZone;
  content: LayerContent;
}

export interface SceneGraph {
  canvas_class: CanvasClass;
  layers: SceneLayer[];
}

export interface BrandBinding {
  role: CreativeRole;
  field: BindableField;
  token: string;
}

export interface CreativeTemplateExamplePayload {
  version: number;
  scene_graph: SceneGraph;
  brand_bindings: BrandBinding[];
  thumbnail_url: string;
  canonical_demo_brand_slug: string;
}

export interface CreativeTemplateExample {
  id: string;
  example_id: string;
  profile_id: string;
  size_key: CanvasClass;
  version: number | null;
  version_id: string | null;
  payload: CreativeTemplateExamplePayload;
  created_at: string;
  updated_at: string;
}

export interface CreativeTemplateExampleVersionSummary {
  id: string;
  version: number;
  created_by: string;
  created_by_email: string;
  created_at: string;
  change_note: string;
}

export interface CreativeTemplateExampleVersionDetail extends CreativeTemplateExampleVersionSummary {
  payload: CreativeTemplateExamplePayload;
}

export interface CreativeTemplateExampleWritePayload {
  example_id?: string;
  profile_id?: string;
  size_key?: CanvasClass;
  scene_graph?: SceneGraph;
  brand_bindings?: BrandBinding[];
  thumbnail_url?: string;
  canonical_demo_brand_slug?: string;
  change_note?: string;
}

export const BINDABLE_FIELD_OPTIONS: BindableField[] = [
  'fill_color',
  'color',
  'background_color',
  'text_color',
  'font_family',
  'content',
  'label',
  'media_url',
];
